import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1105vh61su: FaireBrandEntity = {
  token: "b_1105vh61su",
  type: "brand",
  name: "Baseballism",
  avatarUrl:
    "https://cdn.faire.com/fastly/a9c6e2e493c351684af5931823c1b07156bbdf20b1ee5d3f9cf860ee0c832d47.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/67d0307589d422108cb035bd8abb81be61d84ef0afa4110e6ce17cc528de474f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a9c6e2e493c351684af5931823c1b07156bbdf20b1ee5d3f9cf860ee0c832d47.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/67d0307589d422108cb035bd8abb81be61d84ef0afa4110e6ce17cc528de474f.png",
  location: "Portland, OR, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 49,
  isTopShop: true,
  isInsider: true,
  description:
    "In the beginning, Baseballism was a youth baseball camp founded by four former college baseball players and teammates with a passion to teach the game the right way. The camp ran strong for two years and focused on the fundamentals of the game as well as the life lessons learned on the diamond.\n\nAfter two years of camp the founders went their separate ways; one became a teacher, one a military lawyer, one a sports sales rep and one a finance manager. Five years later the former teammates restored Baseballism as a premium off the field brand focusing on the class, tradition and history of baseball.\n\nNow in a different industry, the roots of the original Baseballism Youth Camp and passion for the game are present in every garment and accessory. A brand built for love of the game.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:52.507Z",
    importedBy: "entity-db-cli",
  },
};
